import { render, staticRenderFns } from "./index-view.vue?vue&type=template&id=5afb0448&"
import script from "./index-view.vue?vue&type=script&lang=js&"
export * from "./index-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports